import Navbar from "../components/Navbar";
import Dashboard from "../components/Dashboard";
import SeoHead from "../components/seo/SeoHead";

function DashboardPage() {
  return (
    <div>
      <SeoHead
        title="Dashboard | Hookora"
        description="Track hook performance, studio usage, analytics, and saved content inside your Hookora dashboard."
        path="/dashboard"
      />
      <Navbar />
      <Dashboard />
    </div>
  );
}

export default DashboardPage;
